export class InfowindowContentBuilder {
  private _content = '';
  private _header = '';
  private _body = '';
  private _footer = '';

  constructor({
    header,
    body,
    footer,
  }: {
    header: string;
    body: string;
    footer: string;
  }) {
    this._header = header;
    this._body = body;
    this._footer = footer;

    this.setContent();
  }

  buildHeader(header: string) {
    this._header = header;
    this.setContent();
  }

  setBody(body: string) {
    this._body = body;
  }

  setFooter(footer: string) {
    this._footer = footer;
  }

  setContent() {
    this._content = `
      <div class="full-container">
        <div class="header">
          ${this._header}
        </div>
        <div class="body-container">
          ${this._body}
        </div>
        <div class="footer">
          ${this._footer}
        </div>
      </div>
    `;
  }

  getContent() {
    return this._content;
  }
}
